export default "__VITE_PUBLIC_ASSET__6948fae4__"